const Swiper = window.Swiper;

jQuery(document).ready(function () {
  const swiper = new Swiper(".swiper", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    pagination: {
      el: ".swiper-pagination",
    },

    spaceBetween: 500,
  });

  const imageSwiper = new Swiper(".image-swiper", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    slidesPerView: "auto",
    centeredSlides: true,
    spaceBetween: 25,
  });

  const swiper3Up = new Swiper(".swiper-3-up", {
    slidesPerView: 1,

    breakpoints: {
      500: {
        slidesPerView: 2,
      },
      800: {
        slidesPerView: 2.5,
      },
    },

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    spaceBetween: 25,
  });

  const swiperNavigator = new Swiper(".swiper-navigator", {
    slidesPerView: 4,

    spaceBetween: 10,

    breakpoints: {
      500: {
        spaceBetween: 25,
        slidesPerView: 5,
      },
      800: {
        spaceBetween: 25,
        slidesPerView: 6,
      },
    },

    watchSlidesProgress: true,
  });

  const swiperNavigated = new Swiper(".swiper-navigated", {
    thumbs: {
      swiper: swiperNavigator,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
});
